import React from "react";

const MsgFrmThePresident = () => {
  return (
    <Decoy />

  );
};

export default MsgFrmThePresident;

function Main() {
  return (
    <div>
      <div
        className="relative h-52 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('/image-fix/msg-from-president/Memory_ A Sestina_.jpeg')",
        }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>

        <div className="relative z-10 flex items-center justify-center h-full text-center">
          <p className="text-white text-2xl font-bold px-4 max-w-2xl">
            Message from Emmanuel Addo, President & Founder
          </p>
        </div>
      </div>

      <div className="max-w-6xl mx-auto p-10">
        <div className="flex items-center space-x-2">
          <div className="h-10 w-1 bg-black"></div>
          <p className="font-dancing text-bold text-2xl">
            “Welcome to the Europpean School of Business & Diplomacy!"
          </p>
        </div>

        <div className="md:flex md:my-5 items-center">
          <div className="md:w-1/2 py-10 md:pr-10 rounded-xl">
            <img
              src="/image-fix/executive-team-images/IMG_6040.JPG"
              alt="Founder's Image"
              className="h-96 w-full object-cover object-top rounded-xl"
            />
          </div>
          <div className="md:w-1/2 space-y-4  text-sm md:text-base text-justify text-gray-700">
            <p>
              As the President & Founder, it is my distinct pleasure to extend a
              warm welcome to all who visit our virtual halls of learning.
              Nestled in the heart of Malta, our institution stands as a beacon
              of excellence in distance education.
            </p>

            <p>
              At the Europpean School of Business & Diplomacy, we are dedicated
              to empowering the leaders of tomorrow. Whether you aspire to
              pursue a certified course, undergraduate program, or postgraduate
              studies in leadership, entrepreneurship, diplomacy, or other
              fields, our institution provides a transformative educational
              experience.
            </p>

            <p>
              As your specialist European accredited distance learning
              institution, we pride ourselves on fostering a dynamic environment
              where students thrive. Our vision is clear: to nurture, train, and
              produce results-oriented, knowledgeable, & world-class leaders who
              will shape the future.
            </p>
          </div>
        </div>

        <div className="max-w-6xl mx-auto text-sm md:text-base mt-3 md:mt-0">
          <p>
            Join us on this journey of discovery & growth. Together, let us
            embark on the path to becoming the leaders our world needs. Welcome
            to the Europpean School of Business & Diplomacy, where the future
            begins today.
          </p>
        </div>
      </div>
    </div>
  );
}

function Decoy() {
  return (
    <div>
      <div className="flex justify-center py-10 px-4">
        <div className="p-5 max-w-4xl space-y-4">
          <div className="p-3 border-b-4 border-sdorange bg-sdorange bg-opacity-30">
            <p className="font-bold text-2xl text-center">
              Content not Avaliable ...
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
